export const invoicesConstants = {
    ...getConstantObj()
};

function getConstantObj() {
    let obj = {
        getInvoiceList_request: "getInvoiceList_request",
        getInvoiceList_success: "getInvoiceList_success",
        getInvoiceList_failure: "getInvoiceList_failure",  

        generateAppendix_request: "generateAppendix_request",
        generateAppendix_success: "generateAppendix_success",
        generateAppendix_failure: "generateAppendix_failure",

        generateInvoice_request: "generateInvoice_request",
        generateInvoice_success: "generateInvoice_success",
        generateInvoice_failure: "generateInvoice_failure",

        postToSQLAccount_request: "postToSQLAccount_request",
        postToSQLAccount_success: "postToSQLAccount_success",
        postToSQLAccount_failure: "postToSQLAccount_failure",

        postCreditNote_request: "postCreditNote_request",
        postCreditNote_success: "postCreditNote_success",
        postCreditNote_failure: "postCreditNote_failure",

        sendEmail_request: "sendEmail_request",
        sendEmail_success: "sendEmail_success",
        sendEmail_failure: "sendEmail_failure",

        deleteInvoice_request: "deleteInvoice_request",
        deleteInvoice_success: "deleteInvoice_success",
        deleteInvoice_failure: "deleteInvoice_failure",
    }

    let obj_formatted = {};
    let domain = "billingPortal.invoices/";
    for (let property in obj) {
        if (obj.hasOwnProperty(property)) {
            obj_formatted[property] = domain + obj[property];
        }
    }

    return obj_formatted;
}